import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Card from '../../layout/Card';
import ModuleHome from '../../layout/ModuleHome';
import { breadcrumbsPropTypes } from '../../common/resource/proptypes/CommonPropTypes';

export const ContractHome = ({ cards, breadcrumbs }) => (
  <ModuleHome
    title="Gestión de Contratos"
    text="Éste es el módulo de Gestión de Contratos."
    cards={cards}
    breadcrumbs={breadcrumbs}
  />
);

const mapStateToProps = ({ ContractUnit }) => ({
  cards: ContractUnit.UnitHome.get('cards'),
  breadcrumbs: ContractUnit.UnitHome.get('breadcrumbs'),
});

ContractHome.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  cards: PropTypes.arrayOf(PropTypes.shape(Card.propTypes)).isRequired,
};

export default connect(mapStateToProps)(ContractHome);
